/**
 * A lodash `mergeWith` customizer that replaces the values under `keys` instead of merging them:
 * merging arrays by index can't shrink a list, and merging objects keeps fields the new value left
 * out. Every other value merges as `merge` would.
 */
export const replaceKeys =
	(keys: readonly string[]) =>
	(_objValue: unknown, srcValue: unknown, key: string): unknown =>
		keys.includes(key) ? srcValue : undefined;
